module.exports = __webpack_public_path__ + "static/media/Dubai_WCCD_white.4e5d385a.png";